"use client";
import { useState } from "react";
import HamburgerButton from "./hamburger-button";
import LogoWrapper from "./logo-wrapper";
import DesktopNav from "./desktop-nav-wrapper";
import MobileNav from "./mobile-nav-wrapper";
import CartWrapper from "./cart-location-wrapper";
import MobileLocationDropdown from "./mobile-location-dropdown";
import GlobalBanner from "@/components/common/global-banner";

const Header = ({ data, locationLinks }) => {
  const headerData = data?.header || {};
  const {
    logo = [],
    left_navigation = [],
    mobile_navigation = [],
    cart_group = {},
    right_navigation = [],
    mobile_navigation_active_index = null,
    reserve_logo = [],
    reserve_link = [],
    mobile_location_heading = "",
    location_links = [],
    mobile_location_links = [],
    mobile_select_location_link = [],
    mobile_change_location_link = [],
    show_location_operating_hours = false,
    global_banner_details = []
  } = headerData;

  const [logoItem] = logo;
  const [reserveLogo] = reserve_logo;
  const [reserveLink] = reserve_link;

  const [isOpen, setIsOpen] = useState(false);

  return (
  <header className="header w-100" id="header">
    <GlobalBanner data={global_banner_details} />
    <div className="header-wrapper d-flex align-items-center">
      <HamburgerButton setIsOpen={setIsOpen} isOpen={isOpen} />

      <MobileNav
        mobileNavigation={mobile_navigation}
        activeIndex={mobile_navigation_active_index}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />

      <LogoWrapper logo={logoItem} />

      <DesktopNav leftNavigation={left_navigation} />

      <CartWrapper
        cartGroup={cart_group}
        rightNavigation={right_navigation}
        reserveLogo={reserveLogo}
        reserveLink={reserveLink}
        locationLinks={location_links}
        mobileLocationHeading={mobile_location_heading}
        mobileChangeLocationLink={mobile_change_location_link}
        mobileLocationLinks={mobile_location_links}
        mobileSelectLocationLink={mobile_select_location_link}
      />
    </div>

    <MobileLocationDropdown
      locationLinks={location_links}
      mobileChangeLocationLink={mobile_change_location_link}
      mobileSelectLocationLink={mobile_select_location_link}
      mobileLocationHeading={mobile_location_heading}
      showLocationOperatingHours={show_location_operating_hours}
    />
  </header>
  );
}

export default Header;
